<template>
  <div style='height: 100%'>
    <!-- 工具栏 -->
    <div class='navbar'>
      <el-button type='primary' icon='sys sys-refresh' class='navbarbtn'
        @click='deepRefreshMainTableContent'>
        刷 新
      </el-button>

      <ExportExcel @click='mainTableExportExcel'></ExportExcel>

      <el-button type='primary' icon='sys sys-expand' class='navbarbtn'
        @click='mainTableExpandRow'>
        展 开
      </el-button>

      <el-button type='primary' icon='sys sys-narrow' class='navbarbtn'
        @click='mainTableNarrowRow'>
        收 起
      </el-button>

      <TableColumnSet :columnSetLoading='mainTable.ColumnSetLoading'
        :showColumnSetDialog='mainTable.showColumnSetDialog'
        :changeShowColumnSetDialog='mainTable.changeShowColumnSetDialog'
        :columnInfo='mainTable.userColumnInfo'
        :tableInfo='mainTable.userTableInfo'
        @updateUserColumnSetDialogReset='mainTableUpdateUserColumnSetDialogReset'
        @saveUserTableColumn='mainTableSaveUserTableColumn'
        @returnDefaultTableColumn='mainTableReturnDefaultTableColumn'
        @showColumnSetDialogMD='mainTableShowColumnSetDialogMD'>
      </TableColumnSet>

      <TableFilterSet :filterSetLoading='mainTable.FilterSetLoading'
        :showFilterSetDialog='mainTable.showFilterSetDialog'
        :changeShowFilterSetDialog='mainTable.changeShowFilterSetDialog'
        :filterInfo='mainTable.userFilterInfo'
        :columnInfo='mainTable.columnInfo'
        @updateUserFilterDialogReset='mainTableUpdateUserFilterDialogReset'
        @saveUserTableFilter='mainTableSaveUserTableFilter'
        @returnDefaultTableFilter='mainTableReturnDefaultTableFilter'
        @showFilterSetDialogMD='mainTableShowFilterSetDialogMD'>
      </TableFilterSet>

      <TableFilter :filterLoading='mainTable.FilterLoading'
        :showFilterDialog='mainTable.showFilterDialog'
        :changeShowFilterDialog='mainTable.changeShowFilterDialog'
        :filterInfo='mainTable.filterInfo'
        :columnInfo='mainTable.columnInfo'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        @showFilterDialogMD='mainTableShowFilterDialogMD'
        @filter='mainTableFilter'>
      </TableFilter>

      <TableFilterOutDisplay v-for='oneFilterInfo in mainTable.filterInfo'
        :key='oneFilterInfo.ColumnCode + oneFilterInfo.FilterType'
        :getSpecialStringArray='mainTableGetSpecialStringArray'
        :columnInfo='mainTable.columnInfo'
        :oneFilterInfo='oneFilterInfo' @filter='mainTableFilter'>
      </TableFilterOutDisplay>

      <el-input v-model='mainTable.qrCode' style='width: 125px;' placeholder='标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>

      <el-input v-model='mainTable.outerQRCode' style='width: 125px;' placeholder='外箱标签号'
        @keyup.enter.native='mainTableFilter()' size='mini' class='filterInput' suffix-icon=''></el-input>
    </div>

    <Table :data='mainTable.tableContent' :tableInfo='mainTable.tableInfo'
      :columnInfo='mainTable.columnInfo' :disPlayColumnInfo='mainTable.disPlayColumnInfo'
      :page-size='mainTable.pageSize' :page='mainTable.page'
      :total='mainTable.total' v-loading='mainTable.Loading'
      :row-style='mainTableRowStyle'
      :reduceHeight='200' :seqFixed='true'
      :showOperationsColumn='true' operationColumnWidth='90px'
      :showDefaultExpandColumn='false' :showExpandColumn='true'
      :getSpecialStringArray='mainTableGetSpecialStringArray'
      :expandRowKeys='mainTable.expandRowKeys'
      @selection-change='mainTableSelectionChange'
      @page-change='mainTablePageChange' @size-change='mainTableSizeChange'
      @sort-change='mainTableSortChange'>
      <template #OperationColumnslot='scope'>
        <el-tooltip effect='dark' content='库位条码盘点' placement='top-start'>
          <el-button type='primary' circle style='padding: 4px;'
            @click='showCheckSPDialogMD(scope)'><i class='sys sys-search'></i>
          </el-button>
        </el-tooltip>
      </template>
      <template #expand='scope'>
        <div class='expand'>
          <div class='expand-inner'>
            <div class='expand-row' style='font-weight: 800; min-width: 60px; text-align: right;'><span style='color: #42426F;'>行号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 200px; text-align: left;'><span style='color: #42426F;'>内箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: right;'><span style='color: #42426F;'>数量</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 180px; text-align: left;'><span style='color: #42426F;'>外箱标签号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 160px; text-align: left;'><span style='color: #42426F;'>供应商批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>批号</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>生产/采购日期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 100px; text-align: left;'><span style='color: #42426F;'>保质期</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>物料代码</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>物料名称</span></div>
            <div class='expand-row' style='font-weight: 800; min-width: 250px; text-align: left;'><span style='color: #42426F;'>物料规格</span></div>
          </div>
        </div>
        <div class='expand'>
          <div v-for='(qrCode, qrCodeIndex) in scope.data.row.detailDt1'
            :key='qrCode.EntryID' class='expand-inner'>
            <div class='expand-row' style='min-width: 60px; text-align: right;'><span style='color: #42426F;'>{{qrCodeIndex + 1}} </span></div>
            <div class='expand-row' style='min-width: 200px; text-align: left;'><span style='color: #42426F;'>{{qrCode.QRCode}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: right;'><span style='color: #42426F;'>{{qrCode.Qty}}{{qrCode.BU_Name}} </span></div>
            <div class='expand-row' style='min-width: 180px; text-align: left;'><span style='color: #42426F;'>{{qrCode.OuterQRCode}} </span></div>
            <div class='expand-row' style='min-width: 160px; text-align: left;'><span style='color: #42426F;'>{{qrCode.SupplyBatchNo}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BatchNo}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFDate}} </span></div>
            <div class='expand-row' style='min-width: 100px; text-align: left;'><span style='color: #42426F;'>{{qrCode.KFPeriod}} </span></div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Number}} </span></div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Name}} </span></div>
            <div class='expand-row' style='min-width: 250px; text-align: left;'><span style='color: #42426F;'>{{qrCode.BI_Model}} </span></div>
          </div>
        </div>
      </template>
    </Table>

    <el-dialog v-dialogDrag title='库位条码盘点' :visible.sync='showCheckSPDialog' fullscreen>
      <div style='margin-top: -35px;'>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          备 注
        </div>
        <el-input v-model='remark' size='mini' style='width: 480px;'
          class='inputField-input'>
        </el-input>
        <div class='inputField-label' style='width: 60px; text-align: left'>
          扫描条码
        </div>
        <el-input v-model='scanQRCode' size='mini' class='inputField-input'
          @keyup.enter.native='scanQRCodeEnterMD' style='width: 200px;'>
        </el-input>
      </div>
      <el-tabs v-model='activeTable'
        type='card' style='background: #fff; height: 100%; margin-top: 40px;'>
        <el-tab-pane label='原库位标签' name='oldQRCodes'>
          <el-table :data='oldQRCodes' border :height='getScanQRCodesTableHeight()'
            ref='oldQRCodesTable' style='margin-top: 0px;'
            :cell-style='mainTableCellStyle' row-key='GUID'
            :row-style='oldQRCodesRowStyle'
            :header-cell-style='mainTableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='QRCode' label='标签号' width='180'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='180'>
            </el-table-column>
            <el-table-column prop='BI_Number' label='物料代码' width='300'>
            </el-table-column>
            <el-table-column prop='BI_Name' label='物料名称' width='350'>
            </el-table-column>
            <el-table-column prop='BI_Model' label='规格' width='250'>
            </el-table-column>
            <el-table-column prop='Qty' label='数量' width='60'>
            </el-table-column>
            <el-table-column prop='BU_Name' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='80'>
            </el-table-column>
            <el-table-column prop='SupplyBatchNo' label='供应商批号' width='180'>
            </el-table-column>
            <el-table-column prop='HaveScanFlag' label='是否扫描' width='100'>
            </el-table-column>
            <el-table-column label='操作' width='60' fixed='right'>
              <template #default='scope'>
                <el-button type='danger' circle style='padding: 4px;'
                  @click='deleteOldQRCode(scope.$index)'><i class='sys sys-delete'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label='已扫标签' name='scanQRCodes'>
          <el-table :data='scanQRCodes' border :height='getScanQRCodesTableHeight()'
            ref='scanQRCodesTable' style='margin-top: 0px;'
            :cell-style='mainTableCellStyle' row-key='GUID'
            :header-cell-style='mainTableHeaderCellStyle' size='medium'>
            <el-table-column type='index' label='序号' width='60'>
            </el-table-column>
            <el-table-column prop='QRCode' label='标签号' width='200'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='180'>
            </el-table-column>
            <el-table-column prop='BI_Number' label='物料代码' width='300'>
            </el-table-column>
            <el-table-column prop='BI_Name' label='物料名称' width='350'>
            </el-table-column>
            <el-table-column prop='BI_Model' label='规格' width='200'>
            </el-table-column>
            <el-table-column prop='Qty' label='数量' width='60'>
            </el-table-column>
            <el-table-column prop='BU_Name' label='单位' width='60'>
            </el-table-column>
            <el-table-column prop='BatchNo' label='批号' width='100'>
            </el-table-column>
            <el-table-column prop='KFDate' label='生产/采购日期' width='120'>
            </el-table-column>
            <el-table-column prop='KFPeriod' label='保质期' width='100'>
            </el-table-column>
            <el-table-column prop='OuterQRCode' label='外箱标签号' width='200'>
            </el-table-column>
            <el-table-column prop='CFOldQRCode' label='拆分前条码号' width='200'>
            </el-table-column>
            <el-table-column prop='ProducetItemID' label='产品专用号' width='200'>
            </el-table-column>
            <el-table-column label='操作' width='60' fixed='right'>
              <template #default='scope'>
                <el-button type='danger' circle style='padding: 4px;'
                  @click='deleteScanQRCode(scope.$index)'><i class='sys sys-delete'></i>
                </el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div class='dialogButtomCenterBtn'>
        <el-button type='primary' @click='checkSP()' size='mini'>确认</el-button>
        <el-button @click='showCheckSPDialog = false' size='mini'>取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import table from '@/components/sys/Table'
import Table from '@/components/sys/Table.vue'
import tableColumnSet from '@/components/sys/TableColumnSet'
import TableColumnSet from '@/components/sys/TableColumnSet.vue'
import tableFilterSet from '@/components/sys/TableFilterSet'
import TableFilterSet from '@/components/sys/TableFilterSet.vue'
import tableFilter from '@/components/sys/TableFilter'
import TableFilter from '@/components/sys/TableFilter.vue'
import TableFilterOutDisplay from '@/components/sys/TableFilterOutDisplay.vue'
import exportExcelHelper from '@/components/export/ExportExcelHelper'
import ExportExcel from '@/components/export/ExportExcel.vue'
import { Loading } from 'element-ui'
import axiosHelper from '@/utils/axiosHelper'

export default {
  name: 'SPCheck',
  components: {
    Table: Table,
    TableColumnSet: TableColumnSet,
    TableFilterSet: TableFilterSet,
    TableFilter: TableFilter,
    TableFilterOutDisplay: TableFilterOutDisplay,
    ExportExcel: ExportExcel
  },
  metaInfo: function () {
    return {
      title: this.menuName
    }
  },
  data: function () {
    return {
      menuCode: '',
      menuName: '',
      mainTable: {
        tableCode: 'WMS_StockPlace',
        tableInfo: {},
        columnInfo: [],
        disPlayColumnInfo: [],
        tableContent: [],
        pageSize: 50,
        page: 1,
        total: 0,
        defaultOrderStr: '',
        orderStr: '',
        defaultFilterStr: '',
        filterStr: '',
        Loading: false,

        detail1FilterStr: '',
        qrCode: '',
        outerQRCode: '',

        userColumnInfo: [],
        userTableInfo: {},
        showColumnSetDialog: false,
        changeShowColumnSetDialog: false,
        ColumnSetLoading: false,

        userFilterInfo: [],
        showFilterSetDialog: false,
        changeShowFilterSetDialog: false,
        FilterSetLoading: false,

        filterInfo: [],
        showFilterDialog: false,
        changeShowFilterDialog: false,
        FilterLoading: false,

        selections: [],
        expandRowKeys: []
      },

      showCheckSPDialog: false,
      oldQRCodes: [],
      activeTable: 'oldQRCodes',
      scanQRCodes: [],
      scanQRCode: '',
      remark: '',
      checkStockID: '',
      checkSPID: ''
    }
  },

  computed: {
    codes: function () {
      return this.$store.state.codes
    }
  },

  created: async function () {
    const that = this
    that.menuCode = that.$route.path.substring(1)
    that.menuName = that.$route.meta.title
    const tableContentPromise = table.refreshTableStructure(that, 'mainTable')
    const tableFilterInfoPromise = tableFilter.refreshTableFliter(that, 'mainTable')

    await tableContentPromise
    await tableFilterInfoPromise
  },

  methods: {
    // 页面主表格深度刷新方法
    deepRefreshMainTableContent: function () {
      const that = this
      that.mainTable.filterStr = that.mainTable.defaultFilterStr
      that.mainTable.orderStr = that.mainTable.defaultOrderStr
      that.refreshMainTableContent()
    },

    // 页面主表格刷新方法
    refreshMainTableContent: function () {
      const that = this
      table.refreshTableContent(that, 'mainTable')
    },

    // 页面主表格换页方法
    mainTablePageChange: function (val) {
      const that = this
      that.mainTable.page = val
      that.refreshMainTableContent()
    },

    // 页面主表格改变每页显示数据条数方法
    mainTableSizeChange: function (val) {
      const that = this
      that.mainTable.page = 1
      that.mainTable.pageSize = val
      that.refreshMainTableContent()
    },

    // 页面主表格排序方式变更方法
    mainTableSortChange: function (column) {
      const that = this
      table.sortChange(column, that, 'mainTable')
    },

    // 页面主表格多选方法
    mainTableSelectionChange: function (selections, row) {
      const that = this
      that.mainTable.selections = selections
    },

    // 页面主表格过滤弹出框显示方法
    mainTableShowFilterDialogMD: function () {
      const that = this
      tableFilter.showTableFliter(that, 'mainTable')
    },

    // 页面主表格过滤方法
    mainTableFilter: function () {
      const that = this
      let detail1FilterStr = ''
      if (that.mainTable.qrCode) {
        const qrCodes = that.mainTable.qrCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < qrCodes.length; i++) {
          detail1FilterStr += " OR QRCode LIKE '%" + qrCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      if (that.mainTable.outerQRCode) {
        const outerQRCodes = that.mainTable.outerQRCode.replace(/，/g, ',').split(',')
        detail1FilterStr += ' AND (1=0 '
        for (let i = 0; i < outerQRCodes.length; i++) {
          detail1FilterStr += " OR OuterQRCode LIKE '%" + outerQRCodes[i] + "%'"
        }
        detail1FilterStr += ')'
      }
      that.mainTable.detail1FilterStr = detail1FilterStr
      tableFilter.filter(that, 'mainTable')
    },

    // 页面主表格栏目设置弹框显示方法
    mainTableShowColumnSetDialogMD: function () {
      const that = this
      tableColumnSet.showTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置重置方法
    mainTableUpdateUserColumnSetDialogReset: function () {
      const that = this
      tableColumnSet.resetTableColumnSet(that, 'mainTable')
    },

    // 页面主表格栏目设置保存方法
    mainTableSaveUserTableColumn: function () {
      const that = this
      tableColumnSet.saveUserTableColumn(that, 'mainTable')
    },

    // 页面主表格栏目设置恢复默认方法
    mainTableReturnDefaultTableColumn: function () {
      const that = this
      tableColumnSet.returnDefaultTableColumn(that, 'mainTable')
    },

    // 页面主表格过滤设置弹框显示方法
    mainTableShowFilterSetDialogMD: function () {
      const that = this
      tableFilterSet.showTableFliterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置重置方法
    mainTableUpdateUserFilterDialogReset: function () {
      const that = this
      tableFilterSet.resetTableFilterSet(that, 'mainTable')
    },

    // 页面主表格过滤设置保存方法
    mainTableSaveUserTableFilter: function () {
      const that = this
      tableFilterSet.saveUserTableFilter(that, 'mainTable')
    },

    // 页面主表格过滤设置恢复默认方法
    mainTableReturnDefaultTableFilter: function () {
      const that = this
      tableFilterSet.returnDefaultTableFilter(that, 'mainTable')
    },

    // 主表行展开方法
    mainTableExpandRow: function () {
      const that = this
      table.expandRow(that, 'mainTable')
    },

    // 主表行收起方法
    mainTableNarrowRow: function () {
      const that = this
      table.narrowRow(that, 'mainTable')
    },

    // 特征字符串转换方法
    mainTableGetSpecialStringArray: function (columnCode) {
      return []
    },

    // 页面主表格行样式设定方法
    mainTableRowStyle: function (data, rowIndex) {
      return {}
    },

    // 主表数据导出为Excel
    mainTableExportExcel: function () {
      const that = this
      exportExcelHelper.exportSYSTableToExcel(that, 'mainTable')
    },

    // 表格单元格样式
    mainTableCellStyle: function () {
      return { padding: '0px' }
    },

    // 表格表头单元格样式
    mainTableHeaderCellStyle: function ({ column, columnIndex, row, rowIndex }) {
      return { padding: '5px', 'background-color': '#f5f7fa' }
    },

    // 获取库位条码盘点扫描标签表格高度
    getScanQRCodesTableHeight: function () {
      return window.innerHeight - 200 + 'px'
    },

    // 库位条码盘点弹出框显示方法
    showCheckSPDialogMD: function (scope) {
      const that = this
      that.showCheckSPDialog = true
      that.oldQRCodes = scope.data.row.detailDt1
      that.scanQRCodes = []
      that.checkStockID = scope.data.row.StockID
      that.checkSPID = scope.data.row.StockPlaceID
      that.remark = ''
      for (let i = 0; i < that.oldQRCodes.length; i++) {
        that.oldQRCodes[i].HaveScanFlag = '未扫'
      }
    },

    // 扫码方法
    scanQRCodeEnterMD: async function () {
      const that = this
      const loadingInstance = Loading.service({ fullscreen: true })
      let qrCodeObj = null
      if (that.scanQRCode.indexOf('|') > 0) {
        that.scanQRCode = that.scanQRCode.substring(0, that.scanQRCode.indexOf('|'))
      }
      let addNum = 0
      qrCodeObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.GetQRCode', {
        qrCode: that.scanQRCode
      })
      if (qrCodeObj.error === '000000') {
        if (qrCodeObj.tableContent.length <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号不存在！')
          that.scanQRCode = ''
          return
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '1') {
            continue
          } else {
            if (qrCodeObj.tableContent[i].StockID !== that.checkStockID) {
              loadingInstance.close()
              that.$message.error('该标签号不在该仓库中！')
              that.scanQRCode = ''
              return
            }
            if (qrCodeObj.tableContent[i].StockPlaceID !== that.checkSPID) {
              loadingInstance.close()
              that.$message.error('该标签号不在该仓位中！')
              that.scanQRCode = ''
              return
            }
            let haveScanFlag = false
            for (let j = 0; j < that.scanQRCodes.length; j++) {
              if (that.scanQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                haveScanFlag = true
              }
            }
            if (haveScanFlag) {
              qrCodeObj.tableContent[i].haveScanFlag = true
            }
            let oldHaveFlag = false
            for (let j = 0; j < that.oldQRCodes.length; j++) {
              if (that.oldQRCodes[j].QRCode === qrCodeObj.tableContent[i].QRCode) {
                oldHaveFlag = true
                break
              }
            }
            if (!oldHaveFlag) {
              loadingInstance.close()
              that.$message.error('页面数据已过期，请刷新后重试！')
              that.scanQRCode = ''
              return
            }
          }
        }
        for (let i = 0; i < qrCodeObj.tableContent.length; i++) {
          if (qrCodeObj.tableContent[i].Status !== '1') {
            continue
          }
          if (qrCodeObj.tableContent[i].haveScanFlag) {
            addNum++
            continue
          }
          that.scanQRCodes.push(qrCodeObj.tableContent[i])
          addNum++
        }
        that.scanQRCode = ''
        if (addNum <= 0) {
          loadingInstance.close()
          that.$message.error('该标签号中的没有在库的内箱标签！')
          return
        }
        that.scanStatusComputer()
      } else {
        that.$message.error('网络异常！')
      }
      loadingInstance.close()
    },

    // 库位条码删除
    deleteOldQRCode: function (index) {
      const that = this
      if (that.oldQRCodes[index].HaveScanFlag === '已扫') {
        that.$message.error('无法删除已扫的原库位标签！')
        return
      }
      that.oldQRCodes.splice(index, 1)
      that.scanStatusComputer()
    },

    // 删除已扫描
    deleteScanQRCode: function (index) {
      const that = this
      that.scanQRCodes.splice(index, 1)
      that.scanStatusComputer()
    },

    // 已扫状态计算
    scanStatusComputer: function () {
      const that = this
      for (let i = 0; i < that.oldQRCodes.length; i++) {
        that.oldQRCodes[i].HaveScanFlag = '未扫'
        for (let j = 0; j < that.scanQRCodes.length; j++) {
          if (that.oldQRCodes[i].QRCode === that.scanQRCodes[j].QRCode) {
            that.oldQRCodes[i].HaveScanFlag = '已扫'
            break
          }
        }
      }
      if (that.$refs.oldQRCodesTable) {
        that.$refs.oldQRCodesTable.doLayout()
      }
    },

    // 原标签表格行样式
    oldQRCodesRowStyle: function (data, rowIndex) {
      if (data.row.HaveScanFlag === '已扫') {
        return { 'background-color': 'lightgreen' }
      } else if (data.row.HaveScanFlag === '未扫') {
        return { 'background-color': '#FF6347' }
      }
    },

    // 库位条码盘点
    checkSP: function () {
      const that = this
      that.$confirm('确定已经扫描完所有该仓库仓位的条了吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const loadingInstance = Loading.service({ fullscreen: true })
        const rtnObj = await axiosHelper.handle('/WebAction/WarehouseManage.Inventory.SPCheck', {
          scanQRCodes: that.scanQRCodes,
          oldQRCodes: that.oldQRCodes,
          remark: that.remark,
          checkStockID: that.checkStockID,
          checkSPID: that.checkSPID
        })
        if (rtnObj.error === '000000') {
          that.refreshMainTableContent()
          that.showCheckSPDialog = false
          if (rtnObj.msg) {
            that.$message.warning('库位条码盘点成功，但是有异常信息！【' + rtnObj.msg + '】')
          } else {
            that.$message.success('库位条码盘点成功！')
          }
        } else {
          that.$message.error(rtnObj.msg)
        }
        loadingInstance.close()
      }).catch(() => {
      })
    }
  }
}
</script>

<style scoped>
.navbar {
  padding-bottom: 0px;
  width: 100%;
  padding: 0;
  margin-bottom: 5px;
  margin-top: -10px;
}
.dialogButtomCenterBtn {
  margin-top: 10px;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.expand {
  padding-left: 46px;
}
.expand-inner {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}
.expand-row {
  margin-right: 10px;
  padding-left: 20p;
  color: blue;
  white-space: nowrap;
}
.filterInput {
  margin-right: 10px;
  margin-top: 6px;
}
.tableInput {
  height: 26px;
  line-height: 26px;
  border: 0px #FFFFFF;
  background-color: transparent;
}
.inputField-label {
  font-size: 14px;
  color: #606266;
  padding-right: 10px;
  vertical-align: middle;
  line-height: 28px;
  float: left;
}
.inputField-input {
  margin-right: 10px;
  float: left;
}
</style>
